var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedirectGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34322 15.7427C6.9527 16.1333 6.9527 16.7664 7.34322 17.1569C7.73374 17.5475 8.36691 17.5475 8.75743 17.1569L16.9498 8.96455L16.9498 15.0356C16.9498 15.5879 17.3975 16.0356 17.9498 16.0356C18.5021 16.0356 18.9498 15.5879 18.9498 15.0356L18.9498 6.55034C18.9498 6.28512 18.8445 6.03077 18.6569 5.84323C18.4694 5.6557 18.215 5.55034 17.9498 5.55034L9.46454 5.55034C8.91226 5.55034 8.46454 5.99806 8.46454 6.55034C8.46454 7.10262 8.91226 7.55034 9.46454 7.55034L15.5356 7.55034L7.34322 15.7427Z",
    fill: "#03F5AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectGreen);
export default __webpack_public_path__ + "static/media/redirect-green.0199ebeefdcefec1245b172d83f3a17e.svg";
export { ForwardRef as ReactComponent };